<template>
	<el-dialog
	  title=""
	  :visible.sync="dialogVisible"
	  :center="true"
	  v-loading="loading"
	  :close-on-click-modal="true"
	  width="30%">
	  <div style="width: 100%;text-align: center;">
		  <i class="el-icon-warning" style="color: #f8bb86;font-size: 128px;"></i>
	  </div>
	  <div style="width: 100%;text-align: center;font-size: 24px;font-weight: bold;margin-top: 20px;">
		  一键填报确认
	  </div>
	  <div style="width: 100%;text-align: center;font-size: 16px;margin-top: 40px;">
		  您已选择志愿{{tianbaoNum}}条，最终填报数量为96项。
	  </div>
	  <div style="width: 100%;text-align: center;font-size: 16px;margin-top: 20px;">
	  	 请选择一键自动填报的记录数：
	  </div>
	  <div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 30px;">
		  <span style="margin-right: 20px;">1</span>
		 <el-input-number style="width: 51%;" v-model="num" :min="0" :max="this.$parent.list.length-this.tianbaoNum" label="记录数"></el-input-number>
	      <span style="color: red;margin-left: 20px;">{{this.$parent.list.length-this.tianbaoNum}}</span>
	  </div>
	  <span slot="footer" class="dialog-footer" style="text-align: center;">
	    <el-button @click="dialogVisible = false">取 消</el-button>
	    <el-button type="success" @click="addAlls()">{{loading?"填报中...":"确认填报"}}</el-button>
	  </span>
	</el-dialog>
</template>

<script>
	import { addAll } from "@/api/gw/volunteer.js"
	export default{
		data(){
			return{
				dialogVisible:false,
				tianbaoNum:0,
				num:0,
				loading:false,
			}
		},
		mounted(){

		},
		props:{

		},
		watch:{
			dialogVisible(e){
				if(e==false){
					this.tianbaoNum = 0
					this.num = 0
					this.loading = false
				}
			},
		},
		methods:{
			show(){
				this.$nextTick(()=>{
					this.dialogVisible = true
					this.tianbaoNum = this.$parent.list.filter(r=>r.is_result==true).length
					this.num = this.$parent.list.length-this.tianbaoNum
				})
			},
			//确认填报
			addAlls(){
				if(this.num==0){
					this.$message.error("请输入填报记录数");
					return;
				}
				if(this.$parent.list.length==0){
					this.$message.error("暂无可填报的专业");
					return;
				}
				//一键填报算法：一键填报要100条，分数跨度为60分，则每一分选中的100/60条进行条包
				let lists = [];
				this.$parent.list.forEach(r => {
					if (!r.is_result) {
						lists.push({
							code: r.code,
							specialty_code: r.specialty_code,
							yugu_score: r.yugu_score,
							id: r.code + r.specialty_code
						})
					}
				})
				lists.sort((a, b) => b.yugu_score - a.yugu_score);
				let newArr = this.sampleArrayByScore(lists, Number(this.num));
				let arr = [];
				newArr.forEach((r, j) => {
					if (arr.length < this.num) {
						arr.push({
							volunteer_id: this.$parent.detail.volunteer_id,
							code: r.code,
							specialty_code: r.specialty_code, //这里使用专业代码
						})
					}
				})
				if(arr.length==0){
					this.$message.error("暂无可填报的专业");
					return;
				}
				this.loading = true
				addAll({
					arr:arr
				}).then(()=>{
          this.$notify({
          title: '一键填报成功',
          message: '',
          type: 'success'
        });
				  this.$parent.yichuList();
				  this.dialogVisible = false
				}).finally(()=>{
					this.loading = false
				})
			},
			sampleArrayByScore(data, N) {
				// 对原始数组按照yugu_score字段降序排序
				data.sort((a, b) => b.yugu_score - a.yugu_score);

				// 提取yugu_score字段的值到一个新数组
				const scores = data.map(item => item.yugu_score);

				// 找到最大值和最小值
				const maxValue = Math.max(...scores);
				const minValue = Math.min(...scores);
				const sum = maxValue - minValue;

				// 计算步长
				const step = sum / N;

				// 存储结果的数组
				const result = [];
				// 跟踪已添加到结果中的id
				const addedIds = new Set();

				// 当前分数初始化为最大值
				let currentScore = maxValue;

				// 遍历N次或直到data遍历完
				for (let i = 0; i < N && i < data.length; i++) {
					// 查找最接近当前分数的项
					let foundItem = null;
					for (let j = 0; j < data.length; j++) {
						if (data[j].yugu_score <= currentScore && !addedIds.has(data[j].id)) {
							foundItem = data[j];
							break;
						}
					}

					// 如果没有找到项，则继续往下减步长，直到找到为止
					if (!foundItem) {
						currentScore -= step;
						continue;
					}

					// 将找到的项加入结果数组，并添加其id到已添加id集合中
					result.push(foundItem);
					addedIds.add(foundItem.id);

					// 更新当前分数为下一个要查找的分数
					currentScore -= step;
				}

				// 如果结果数组的长度小于N，说明没有足够的不重复id来满足N的数量要求
				// 在这种情况下，您可能需要调整逻辑，例如通过返回所有不重复的项，或者抛出一个错误/警告
				if (result.length < N) {
					// 这里处理结果数量不足N的情况，例如返回所有不重复的项
					return Array.from(addedIds).map(id => data.find(item => item.id === id));
				}

				return result;
			},
		}
	}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/volunteer/components/Onekey.vue